import { Injectable } from '@angular/core';
import { ConfirmDialogData } from '../models/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  confirmDialog_init(): ConfirmDialogData {
    let data: ConfirmDialogData = {
      show: false,
      data: {
        header: "",
        body_text: "",
        cancel_btn_label: "",
        cancel_btn_class: "",
        cancel_btn_display: true,
        confirm_btn_label: "",
        confirm_btn_class: "",
        confirm_btn_display: true,
      }
    };
    return data;
  }
}
